(function() {

	angular
		.module('ngmvac')
		.controller('cotizadorAutosCtrl', cotizadorAutosCtrl);

		cotizadorAutosCtrl.$inject = ['$window', '$filter', 'ReservationFactory', 'HotelFactory', 'ContentApiService', 'timeService', 'AutoFactory'];

		function cotizadorAutosCtrl($window, $filter, ReservationFactory, HotelFactory, ContentApiService, timeService, AutoFactory) {
            var vm       = this;
            vm.countries = [];
            vm.destinos  = [];
            vm.place     = 'Aeropuerto'; //-Aeropuerto
            vm.pickup    = "10:00 AM";
            vm.dropoff   = "10:00 AM";
            vm.places    = ['Aeropuerto', 'Centro'];
            vm.step      = ($window.location.pathname == '/autos') ? 1 : (($window.location.pathname == '/autos/flota') ? 2 : 3);
		    AutoFactory.setTipo(vm.step);

            AutoFactory.getHoras().then(function(response){
                vm.hours = response.data;
            });

            $('#destino_auto').bind('typeahead:select', function(ev, data) {
                vm.iata = data.clave;
                vm.ciudad = data.ciudad;
            });

            vm.search = function(){
                var params = {
                    params : {
                        hora_pu     : vm.pickup,
                        hora_do     : vm.dropoff,
                        ubicacion   : vm.place,
                        ubicacion_do: vm.place,
                        IATA        : vm.iata,
                        fhInicio    : moment( $('#carFhInicio').val() ).format('YYYY-MM-DD'),
                        fhFin       : moment( $('#carFhFin').val() ).format('YYYY-MM-DD'),
                        ciudad      : vm.ciudad
                    }
                }

                AutoFactory.get(params).then(function(response){
                    if(response.status == 204){
                        $window.location.href= '/autos';
                    }
                    $window.location.href = '/autos/flota';
                });
            }

        }
        
})();
